import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissionData } from '../Counter/permissionData';
import { postApi } from '../Services/apiService';
import { toast } from 'react-toastify';
import { clearIdsStatus } from '../Counter/createGroup';
Modal.setAppElement('#root');

function Sidebar({ loader, setLoader,showSidebar, handleToggleSidebar }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownValue, setDropdownValue] = useState('');
  //   const [loader, setLoader] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { data, status, error } = useSelector((state) => state.roleData);
  console.log(data, "sidebar-data")
  const isActive = (path) => location.pathname === path;
  
  const toggleDropdown = (value) => {
    setDropdownValue(dropdownValue === value ? '' : value);
  };

  const openLogoutModal = (e) => {
    e.preventDefault();
    setIsLogoutModalOpen(true);
  };

  const closeLogoutModal = () => {
    setIsLogoutModalOpen(false);
  };

  // const handleLogout = () => {
  //   localStorage.clear();
  //   closeLogoutModal();
  //   navigate('/');
  // };

  const handleLogout = async () => {
    setIsLoggingOut(true); // Start loading
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await postApi("/logout", null, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (response?.success) {
        console.log(response)
      } else {
        toast.error(response?.message || "Logout failed");
      }
    } catch (error) {
      console.error("Logout error:", error);
      toast.error(error.response?.data?.msg || "An error occurred during logout");
    } finally {
      localStorage.clear();
      closeLogoutModal();
      navigate('/');
      setIsLoggingOut(false);
    }
  };

  useEffect(() => {
    if (!data) {
      getPermissionData();
    }
  }, []);
  useEffect(() => {
    if(showSidebar){
      setDropdownValue('');
    }
  }, [showSidebar]);

  const getPermissionData = async () => {
    setLoader(true);
    await dispatch(fetchPermissionData());
    setLoader(false);
  };

  const canView = (name) => {
    return data?.permissions?.find((item) => item.name === name)?.view === 1;
  };

  const hasAnyPermission = (permissionNames) => {
    return permissionNames.some(name => canView(name));
  };

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '400px',
      borderRadius: '8px',
      padding: '20px',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
  };

  return (
     <div className={`left-bar`}>
      {/* {loader ? (
        <div className="text-center py-3">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : ( */}
      <nav id="sidebar">
        <div className="top">
          <a href="#" className="main-logo">
            <img
              src={window.getPublicUrl(`/assets/images/${showSidebar?'sidebar-logo-collapse.svg':'sidebar-logo.svg'}`)}
              alt=""
            />
          </a>
          
          <button className="toggle-btn border-0 bg-none" onClick={()=>handleToggleSidebar()}>
            <img
              src={window.getPublicUrl('/assets/images/side-bar-arrow.svg')}
              alt=""
            />
          </button>
        </div>
        <ul>
          <li
            className={isActive('/admin/dashboard') ? 'active' : ''}
            onClick={() => {setDropdownValue('');
              // dispatch(clearIdsStatus())
            }}
          >
            <Link to="/admin/dashboard">
              <img
                src={window.getPublicUrl('/assets/images/dashboard-icon.svg')}
                alt=""
              />
              Dashboard
            </Link>
          </li>
          <li className="no-hover">
            <a href="#">
              <p>Inventory</p>
            </a>
          </li>
          {canView('arrival') && (
            <li className={isActive('/admin/arrival') ? 'active' : ''} onClick={()=>handleToggleSidebar(true)}>
              <Link to="/admin/arrival">
                <img
                  src={window.getPublicUrl('/assets/images/admin-img.svg')}
                  alt=""
                />
                Arrival
              </Link>
            </li>
          )}
          {canView('direct_in_out') && (
            <li className={isActive('/admin/inout') ? 'active' : ''} onClick={()=>handleToggleSidebar(true)}>
              <Link to="/admin/inout">
                <img
                  src={window.getPublicUrl('/assets/images/sale-img.svg')}
                  alt=""
                />
                Direct - IN & OUT
              </Link>
            </li>
          )}
          {canView('prepack_in_out') && (
            <li className={isActive('/admin/prepack-inout') ? 'active' : ''} onClick={()=>handleToggleSidebar(true)}>
              <Link to="/admin/prepack-inout">
                <img
                  src={window.getPublicUrl('/assets/images/prepack-icon.svg')}
                  alt=""
                />
                Prepack - IN & OUT
              </Link>
            </li>
          )}
          {canView('reserve') && (
            <li className={isActive('/admin/reserve') ? 'active' : ''} onClick={()=>handleToggleSidebar(true)}>
              <Link to="/admin/reserve" onClick={()=>localStorage.removeItem('reserveMethod')}>
                <img
                  src={window.getPublicUrl('/assets/images/import-img.svg')}
                  alt=""
                />
                Reserve
              </Link>
            </li>
          )}
          {canView('daily_inventory') && (
            <li className={isActive('/admin/daily-inventory') ? 'active' : ''} onClick={()=>{if(!isActive('/admin/daily-inventory')){localStorage.removeItem('inventoryFilter')}handleToggleSidebar(true)} }>
              <Link to="/admin/daily-inventory">
                <img
                  src={window.getPublicUrl('/assets/images/product-img.svg')}
                  alt=""
                />
                Daily Inventory
              </Link>
            </li>
          )}
          {/* <li className={isActive('/admin/chat') ? 'active' : ''}>
            <Link to="/admin/chat">
              <img
                src={window.getPublicUrl('/assets/images/chat-img.svg')}
                alt=""
              />
              Chat
            </Link>
          </li> */}

          <li className="no-hover">
            <a href="#">
              <p>Master Data</p>
            </a>
          </li>

          {hasAnyPermission(['product_list', 'product_grouping', 'order_arrival', 'category', 'origin', 'prepack_product_list']) && (
            <li>
              <button
                className={`dropdown-btn ${dropdownValue === 'product' ? 'active' : ''}`}
                onClick={() => {toggleDropdown('product');handleToggleSidebar(true);}}
              >
                <img
                  src={window.getPublicUrl('/assets/images/reserve-img.svg')}
                  alt=""
                />
                <span>Products</span>
                <img
                  className="arrow"
                  src={window.getPublicUrl(
                    dropdownValue === 'product'
                      ? '/assets/images/Frame-arrow.svg'
                      : '/assets/images/arrow-bottom-white.png'
                  )}
                  alt=""
                />
              </button>
              {dropdownValue === 'product' && (
                <ul className="sub-menu">
                  {canView('product_list') && (
                    <li className={isActive('/admin/product') ? 'active' : ''}>
                      <Link to="/admin/product" onClick={()=>{dispatch(clearIdsStatus())}}>Product List</Link>
                    </li>
                  )}
                  {canView('prepack_product_list') && (
                    <li className={isActive('/admin/prepack-product') ? 'active' : ''}>
                      <Link to="/admin/prepack-product" onClick={()=>{dispatch(clearIdsStatus())}}>Prepack Product</Link>
                    </li>
                  )}
                  {canView('product_grouping') && (
                    <li className={isActive('/admin/product-group') ? 'active' : ''}>
                      <Link to="/admin/product-group" onClick={()=>{dispatch(clearIdsStatus())}}>Product Group</Link>
                    </li>
                  )}
                  {canView('order_arrival') && (
                    <li className={isActive('/admin/order-arrival-date') ? 'active' : ''}>
                      <Link to="/admin/order-arrival-date">
                        Order Arrival Date Master
                      </Link>
                    </li>
                  )}
                  {canView('category') && (
                    <li className={isActive('/admin/category') ? 'active' : ''}>
                      <Link to="/admin/category">Category</Link>
                    </li>
                  )}
                  {canView('origin') && (
                    <li className={isActive('/admin/origin') ? 'active' : ''}>
                      <Link to="/admin/origin">Origin</Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

          {hasAnyPermission(['buyer_member', 'supplier_list', 'shipping_method']) && (
            <li>
              <button
                className={`dropdown-btn ${dropdownValue === 'import' ? 'active' : ''}`}
                onClick={() => {toggleDropdown('import'); handleToggleSidebar(true);}}
              >
                <img
                  src={window.getPublicUrl('/assets/images/direct.svg')}
                  alt=""
                />
                <span>Import</span>
                <img
                  className="arrow"
                  src={window.getPublicUrl(
                    dropdownValue === 'import'
                      ? '/assets/images/Frame-arrow.svg'
                      : '/assets/images/arrow-bottom-white.png'
                  )}
                  alt=""
                />
              </button>
              {dropdownValue === 'import' && (
                <ul className="sub-menu">
                  {canView('buyer_member') && (
                    <li className={isActive('/admin/buyer') ? 'active' : ''}>
                      <Link to="/admin/buyer">Buyer Member</Link>
                    </li>
                  )}
                  {canView('supplier_list') && (
                    <li className={isActive('/admin/supplier') ? 'active' : ''}>
                      <Link to="/admin/supplier">Supplier List</Link>
                    </li>
                  )}
                  {canView('shipping_method') && (
                    <li className={isActive('/admin/shipping-method') ? 'active' : ''}>
                      <Link to="/admin/shipping-method">Shipping Method</Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

          {hasAnyPermission(['sales_member', 'customer_group']) && (
            <li>
              <button
                className={`dropdown-btn ${dropdownValue === 'sales' ? 'active' : ''}`}
                onClick={() => {toggleDropdown('sales'); handleToggleSidebar(true);}}
              >
                <img
                  src={window.getPublicUrl('/assets/images/arival-img.svg')}
                  alt=""
                />
                <span>Sales</span>
                <img
                  className="arrow"
                  src={window.getPublicUrl(
                    dropdownValue === 'sales'
                      ? '/assets/images/Frame-arrow.svg'
                      : '/assets/images/arrow-bottom-white.png'
                  )}
                  alt=""
                />
              </button>
              {dropdownValue === 'sales' && (
                <ul className="sub-menu">
                  {canView('sales_member') && (
                    <li className={isActive('/admin/sales') ? 'active' : ''}>
                      <Link to="/admin/sales">Sales Member</Link>
                    </li>
                  )}
                  {canView('customer_group') && (
                    <li className={isActive('/admin/customer') ? 'active' : ''}>
                      <Link to="/admin/customer">Customer Group</Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

          {hasAnyPermission(['admin_member']) && (
            <li>
              <button
                className={`dropdown-btn ${dropdownValue === 'admin' ? 'active' : ''}`}
                onClick={() => {toggleDropdown('admin'); handleToggleSidebar(true);}}
              >
                <img
                  src={window.getPublicUrl('/assets/images/user-pro.svg')}
                  alt=""
                />
                <span>Admin</span>
                <img
                  className="arrow"
                  src={window.getPublicUrl(
                    dropdownValue === 'admin'
                      ? '/assets/images/Frame-arrow.svg'
                      : '/assets/images/arrow-bottom-white.png'
                  )}
                  alt=""
                />
              </button>
              {dropdownValue === 'admin' && (
                <ul className="sub-menu">
                  {canView('admin_member') && (
                    <li className={isActive('/admin/admin-member') ? 'active' : ''}>
                      <Link to="/admin/admin-member">Admin Member</Link>
                    </li>
                  )}
                </ul>
              )}
            </li>
          )}

          <li>
            <a href="#" onClick={openLogoutModal}>
              <img
                src={window.getPublicUrl('/assets/images/logout1.svg')}
                alt=""
              />
              Logout
            </a>
          </li>
        </ul>
      </nav>
      {/* )} */}

      <Modal
        isOpen={isLogoutModalOpen}
        onRequestClose={closeLogoutModal}
        style={customStyles}
        contentLabel="Logout Confirmation"
        className={'logout'}
      >
        <div className="">
       
          <div className="modal-header">
              <h3>Confirm Logout</h3>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                className="close"
                alt="Close"
              />
            </div>
          <p>Are you sure you want to logout?</p>
          <div className="d-flex justify-content-end mt-4">
            <button
              onClick={closeLogoutModal}
              className="reset me-2 mt-3"
            >
              Cancel
            </button>
            <button onClick={handleLogout} className="save" disabled={isLoggingOut}>
              {isLoggingOut ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Logging out...
                </>
              ) : (
                "Logout"
              )}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Sidebar;